import React from 'react'
import { SessionsViewProps } from '../types'
import { WebinarSessionsList } from '../components'
import { formatDateTime, formatDuration } from '../components'

const SessionsView: React.FC<SessionsViewProps> = ({
  sessions,
  currentPage,
  pageSize,
  onPageChange,
  isAllTab,
  allWebinarTypes,
}) => (
  <WebinarSessionsList
    sessions={sessions}
    formatDateTime={formatDateTime}
    formatDuration={formatDuration}
    page={currentPage}
    pageSize={pageSize}
    onPageChange={onPageChange}
    isAllTab={isAllTab}
    allWebinarTypes={allWebinarTypes}
  />
)

export default SessionsView
